import {grayColor} from '../../cmsMainStyle'

const dividerTextStyle = theme => ({
	title: {
		fontFamily: "Arial, Helvetica, sans-serif",
		fontSize: 15,
		color: grayColor[4],
	}
})


export default dividerTextStyle